import { useEditorState } from '@udecode/plate-common';
import { aiWriterPlateId } from 'features/aiWriter/AiWriter';

const useEditor = () => useEditorState(aiWriterPlateId);

export default useEditor;
